import React, { useState, useEffect } from 'react';
import { Switch } from '@material-ui/core';
import { useMutation } from '@apollo/client';
import { SET_WRITER_PUBLISH_PERMISSION } from '../../../queries/writer';

export const PublishPermission = ({ id, canPublish }) => {
  const [publish, setPublish] = useState(false);
  const [publishPermission] = useMutation(SET_WRITER_PUBLISH_PERMISSION);

  useEffect(() => {
    setPublish(canPublish);
  }, [canPublish]);

  const handleChange = (e) => {
    setPublish(e.target.checked);
    publishPermission({ variables: { id, canPublish: e.target.checked } });
  };

  return (
    <div>
      <Switch
        checked={publish}
        onChange={handleChange}
        name="checkedA"
        color="primary"
        inputProps={{ 'aria-label': 'checkbox' }}
      />
    </div>
  );
};
